(function(app) {

    app.directive("onlyDigits",
        function() {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function(scope, elelment, attrs, modelCtrl) {
                    modelCtrl.$parsers.push(function(inputValue) {
                        if (inputValue == undefined) return '';

                        var transformedInput = inputValue.replace(/[^0-9]/g, '');
                        if (transformedInput !== inputValue) {
                            modelCtrl.$setViewValue(transformedInput);
                            modelCtrl.$render();
                        }

                        return transformedInput;
                    });
                }
            }
        });

})(window.app); //jshint ignore:line